var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 124,
    viewBox: "0 0 136 124",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7022 18.7161C100.45 16.6413 100.194 13.5249 97.9868 11.9487C88.0739 4.87052 76.247 0.873072 63.9977 0.524837C50.1066 0.129929 36.4913 4.45128 25.3705 12.7847C14.2497 21.118 6.27901 32.9722 2.75744 46.4152C-0.764132 59.8583 0.370996 74.0978 5.97784 86.8132C11.5847 99.5286 21.3327 109.97 33.6333 116.437C45.9339 122.903 60.0619 125.013 73.7149 122.422C87.368 119.831 99.7412 112.693 108.818 102.17C116.822 92.8913 121.847 81.4631 123.307 69.3702C123.632 66.6773 121.503 64.3871 118.793 64.2779C116.082 64.1687 113.821 66.2834 113.455 68.9712C112.111 78.8442 107.934 88.1566 101.38 95.7542C93.753 104.596 83.3561 110.594 71.8837 112.771C60.4114 114.948 48.5399 113.175 38.204 107.742C27.8681 102.308 19.6771 93.5344 14.9658 82.8499C10.2545 72.1655 9.30066 60.2004 12.2598 48.9045C15.2189 37.6086 21.9164 27.6478 31.261 20.6455C40.6055 13.6431 52.0462 10.012 63.7185 10.3438C73.7482 10.629 83.4409 13.8257 91.6369 19.492C93.8682 21.0345 96.9549 20.7909 98.7022 18.7161Z",
    fill: "#00A68B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.25 20.5L64.6272 83.126L37.2988 55.6562",
    stroke: "#00A68B",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess2);
export default __webpack_public_path__ + "static/media/success2.b05246be.svg";
export { ForwardRef as ReactComponent };